import React from "react";
import { theme, Tooltip, Modal } from 'antd';
import {
  PlusCircleFilled,
  EditOutlined,
  ClearOutlined,
  CloseCircleFilled,
  CheckCircleFilled,
  ExclamationCircleOutlined,
  RedoOutlined,
  PlusOutlined,
  MinusOutlined
} from '@ant-design/icons';
import ColorButton from "../../common/ColorButton";
import TSTable from "../../common/TSTable";
import { URL_SKIM } from "../../constants/urls";
import { dateToHumanString, toFixed } from "../../frameworks/Util";
import ErrorMessages from "../../common/ErrorMessages";
import { POST } from "../../frameworks/HttpClient";
import AddSkimChemicalStockModal from "./AddSkimChemicalStockModal";
import { ORANGE_COLOR, PRINT_COLOR } from "../../constants/color";
import ManageStockSkimChemicalModal from "./ManageStockSkimChemicalModal";

export default function   SkimChemicalStockList(props) {
  const [ errorMessages, setErrorMessages ] = React.useState(false);
  const [ chemicalTarget, setChemicalTarget] = React.useState(null);
  const [ openManageModal, setOpenManageModal] = React.useState(null);
  const [ manageTarget, setManageTarget] = React.useState(null);

  const tableRef = React.useRef(null);
  const {
    token: { colorSuccess },
  } = theme.useToken();

  const { token : { colorWarning, colorPrimary, colorError }} = theme.useToken();

  const columns = [
    {
      title: 'Action',
      dataIndex: '',
      width : 200,
      key: 'action',
      render: (_, original) => {
        return (
          <div 
            style={{textAlign:'center'}}
            onClick={(e) => {
              e.stopPropagation()
            }}
          >
            {!original.is_closed && <Tooltip triger='hover' title="ล้างสต๊อก">
              <ColorButton 
                type='primary'
                override={colorPrimary}
                icon={<ClearOutlined />}
                style={{ margin : 5}}
                onClick={()=> confirm(original.lot_no, original.id)} 
              />
            </Tooltip>}
            {!original.is_closed && <Tooltip triger='hover' title="แก้ไข">
              <ColorButton 
                type='primary'
                override={colorWarning}
                icon={<EditOutlined />}
                style={{ margin : 5}}
                onClick={()=> setChemicalTarget(original)} 
              />
            </Tooltip>}
            {/* {!original.is_closed && <Tooltip triger='hover' title="เพิ่มสต๊อก">
              <ColorButton 
                type='primary'
                override={colorSuccess}
                icon={<PlusOutlined />}
                style={{ margin : 5}}
                onClick={()=> {
                  setOpenManageModal('add')
                  setManageTarget(original)
                }}
              />
            </Tooltip>} */}
            {!original.is_closed && <Tooltip triger='hover' title="ตัดสต๊อก">
              <ColorButton 
                type='primary'
                override={ORANGE_COLOR}
                icon={<MinusOutlined />}
                style={{ margin : 5}}
                onClick={()=> {
                  setOpenManageModal('withdraw')
                  setManageTarget(original)
                }}
              />
            </Tooltip>}
            {original.is_closed && <Tooltip triger='hover' title="ย้อนกลับ">
              <ColorButton 
                type='primary'
                override={PRINT_COLOR}
                icon={<RedoOutlined />}
                style={{ margin : 5}}
                onClick={()=>  confirmRevert(original.lot_no, original.id)} 
              />
            </Tooltip>}
          </div>
      )}
    },
    {
      title: 'วันที่นำเข้า',
      dataIndex: 'input_date',
      key: 'input_date',
      render : (value) => <center>{value ? dateToHumanString(value) : '-'}</center>
    },
    {
      title: 'ชื่อสารเคมี',
      dataIndex: 'chemical_name',
      key: 'chemical_name',
      searcher: true,
    },
    {
      title: 'Lot No.',
      dataIndex: 'lot_no',
      key: 'lot_no',
      searcher: true,
    },
    {
      title: 'วันที่หมดอายุ',
      dataIndex: 'expire_date',
      key: 'expire_date',
    },
    {
      title: 'ปริมาณนำเข้า',
      dataIndex: 'amount',
      key: 'amount',
      render : (value) => toFixed(value, 2)
    },
    {
      title: 'คงเหลือ',
      dataIndex: 'remain_amount',
      key: 'remain_amount',
      render : (value) => toFixed(value, 2)
    },
    {
      title: 'บริษัทผู้จำหน่าย',
      dataIndex: 'supplier_name',
      key: 'supplier_name',
      render : (value) => value ?? "-"
    },
    {
      title: 'สถานะ',
      dataIndex: 'is_closed',
      key: 'is_closed',
      render : (value) =>  <center>{value ? <CloseCircleFilled style={{ color : colorError}}/> : <CheckCircleFilled style={{ color : colorSuccess}}/>}</center>
    },
  ]

  const confirm = (title, value) => {
    Modal.confirm({
      title: `ล้างสต๊อกสารเคมีสกิม - ${title}`,
      icon: <ExclamationCircleOutlined style={{ color : colorError}} />,
      content: 'คุณต้องการล้างสต๊อกสารเคมีสกิมใช่หรือไม่ ?',
      okText: 'ใช่',
      cancelText: 'ไม่ใช่',
      maskClosable: true,
      okButtonProps: {style: { backgroundColor : colorError}},
      onOk:async() => {
        await handleClearStock(value)
        refreshData();
      },
    });
  };

  const confirmRevert = (title, value) => {
    Modal.confirm({
      title: `ย้อนกลับสต๊อกสารเคมีสกิม - ${title}`,
      icon: <ExclamationCircleOutlined style={{ color : colorError}} />,
      content: 'คุณต้องการย้อนกลับสต๊อกสารเคมีสกิมใช่หรือไม่ ?',
      okText: 'ใช่',
      cancelText: 'ไม่ใช่',
      maskClosable: true,
      okButtonProps: {style: { backgroundColor : colorError}},
      onOk:async() => {
        await handleRevertStock(value)
        refreshData();
      },
    });
  };

  const refreshData = async() => {
    if(tableRef.current)(
      await tableRef.current.fetchWithoutResetPage()
    )
  }


  const handleClearStock = async(id) => {
    setErrorMessages(null)
    try {
      await POST(`${URL_SKIM.SKIM_CHEMICAL_TRANSACTION}${id}/close/`)
    } catch (error) {
      setErrorMessages(error.errorMessages)
    }
  }

  const handleRevertStock = async(id) => {
    setErrorMessages(null)
    try {
      await POST(`${URL_SKIM.SKIM_CHEMICAL_TRANSACTION}${id}/reactivate/`)
    } catch (error) {
      setErrorMessages(error.errorMessages)
    }
  }
  

  return(
    <div>
      <ErrorMessages message={errorMessages}></ErrorMessages>
      <ColorButton
        type={'primary'}
        override={colorSuccess}
        style={{ float : 'right', marginBottom : 10}}
        icon={<PlusCircleFilled />} 
        onClick={() => setChemicalTarget('add')}>
          {"เพิ่มสต๊อกสารเคมี"}
      </ColorButton>

      <TSTable
        ref={tableRef}
        columns={columns}
        size={'small'}
        url={URL_SKIM.SKIM_CHEMICAL_TRANSACTION}
      />

      <AddSkimChemicalStockModal
        open={chemicalTarget ? true : false}
        onClose={() => setChemicalTarget(null)}
        onUpdate={() => {
          setChemicalTarget(null)
          refreshData();
        }}
        target={chemicalTarget}
      />

      <ManageStockSkimChemicalModal
        open={openManageModal ? true : false}
        target={manageTarget}
        direction={openManageModal}
        onClose={() => {
          setOpenManageModal(null);
          setManageTarget(null);
        }}
        onUpdate={() => {
          setOpenManageModal(false);
          setManageTarget(null);
          refreshData();
        }}
      />
    </div>
  )
}